(() => {
  if (window.__dalraCountdownV1) return;
  window.__dalraCountdownV1 = true;

  const selector = '.dalra-countdown[data-end]';
  const timers = new Map();
  let interval = null;
  let scheduled = false;
  const pad = value => String(value).padStart(2, '0');

  function parseEnd(value) {
    const raw = String(value || '').trim();
    if (!/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}(?::\d{2})?(?:\.\d+)?(?:Z|[+-]\d{2}:\d{2})?$/.test(raw)) return NaN;
    return Date.parse(/(?:Z|[+-]\d{2}:\d{2})$/.test(raw) ? raw : raw + '+08:00');
  }

  function hasLegacyScript() {
    return Array.from(document.scripts).some(script => {
      const code = script.textContent || '';
      return !script.src && code.includes('dalra-countdown') &&
        code.includes('setInterval') && code.includes('預購已截止');
    });
  }

  function stop() {
    if (interval !== null) window.clearInterval(interval);
    interval = null;
  }

  function update() {
    let active = false;
    const now = Date.now();
    timers.forEach((state, timer) => {
      if (!timer.isConnected) {
        timers.delete(timer);
        return;
      }
      const diff = state.end - now;
      let text;
      if (!Number.isFinite(diff)) {
        text = '日期待確認';
      } else if (diff <= 0) {
        text = '預購已截止';
        if (timer.parentElement) {
          timer.parentElement.style.color = timer.getAttribute('data-expired-color') ||
            window.getComputedStyle(timer).getPropertyValue('--muted').trim() || '#8c7d6b';
        }
      } else {
        active = true;
        if (timer.parentElement) timer.parentElement.style.color = state.originalColor;
        const days = Math.floor(diff / 86400000);
        const hours = Math.floor(diff / 3600000) % 24;
        const minutes = Math.floor(diff / 60000) % 60;
        const seconds = Math.floor(diff / 1000) % 60;
        text = `${days}天 ${pad(hours)}時 ${pad(minutes)}分 ${pad(seconds)}秒`;
      }
      if (timer.textContent !== text) timer.textContent = text;
    });
    if (active && interval === null) interval = window.setInterval(update, 1000);
    if (!active) stop();
  }

  function scan() {
    scheduled = false;
    const content = document.getElementById('MainContent');
    if (!content || content.getAttribute('data-dalra-preorder') !== 'true' || hasLegacyScript()) {
      timers.clear();
      stop();
      return;
    }
    content.querySelectorAll(selector).forEach(timer => {
      const raw = timer.getAttribute('data-end');
      const previous = timers.get(timer);
      if (!previous || previous.raw !== raw) {
        timers.set(timer, {
          raw,
          end: parseEnd(raw),
          originalColor: previous ? previous.originalColor : (timer.parentElement?.style.color || '')
        });
      }
    });
    update();
  }

  function queueScan() {
    if (scheduled) return;
    scheduled = true;
    window.requestAnimationFrame(scan);
  }

  function start() {
    scan();
    const root = document.body;
    if (root) {
      new MutationObserver(queueScan).observe(root, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['data-end', 'class', 'data-dalra-preorder']
      });
    }
    document.addEventListener('shopify:section:load', queueScan);
    window.addEventListener('pageshow', queueScan);
    document.addEventListener('visibilitychange', () => {
      if (!document.hidden) queueScan();
    });
    window.addEventListener('pagehide', stop);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
